<div>
    <h2 class="text-3xl font-semibold text-center mb-12">Kontakt</h2>
    <form
        class="flex flex-col space-y-4"
        name="contact"
        action="https://formspree.io/f/xrgynayz"
        method="POST"
    >
        <div class="flex space-x-4">
            <div class="flex flex-1">
                <label class="sr-only" for="name">Dit navn</label>
                <input
                    id="name"
                    class="form-element"
                    type="text"
                    name="name"
                    placeholder="Navn"
                    required
                />
            </div>
            <div class="flex flex-1">
                <label class="sr-only" for="email">Din Email adresse</label>
                <input
                    id="email"
                    class="form-element"
                    type="text"
                    name="email"
                    placeholder="Email"
                    required
                />
            </div>
            <div class="flex flex-1">
                <label class="sr-only" for="subject">Emne</label>
                <input
                    id="subject"
                    class="form-element"
                    type="text"
                    name="subject"
                    placeholder="Emne"
                    required
                />
            </div>
        </div>
        <div>
            <label class="sr-only" for="message">Din besked</label>
            <textarea
                id="message"
                class="form-element"
                name="message"
                rows="6"
                placeholder="Din besked"
                required
            />
        </div>
        <button
            type="submit"
            class="mx-auto bg-sky-700 text-white px-6 py-3 rounded-3xl"
        >
            Send
        </button>
    </form>
</div>
  